import { render, staticRenderFns } from "./DrawingCanvas.vue?vue&type=template&id=4212b509&scoped=true&"
import script from "./DrawingCanvas.vue?vue&type=script&lang=js&"
export * from "./DrawingCanvas.vue?vue&type=script&lang=js&"
import style0 from "./DrawingCanvas.vue?vue&type=style&index=0&id=4212b509&scoped=true&lang=css&"
import style1 from "./DrawingCanvas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4212b509",
  null
  
)

export default component.exports